// MaterialsUsed.js
import React from 'react';
import '../styles/MaterialsUsed.css';

const MaterialsUsed = () => {
  return (
    <section className="materials-used">
      <h2>Materials Used</h2>
      <p>Details on construction materials and finishes.</p>
    </section>
  );
};

export default MaterialsUsed;